import { useQuery } from '@tanstack/react-query';
import getSSOProvider from '@/API/SSO/getSSOProvider';

const useGetSSOProvider = (providerId, { enabled = true } = {}) => {
    return useQuery({
        queryKey: ['ssoProvider', providerId],
        queryFn: () => getSSOProvider(providerId),
        enabled: enabled && !!providerId,
        refetchOnWindowFocus: false,
        staleTime: 0,
    });
};

export default useGetSSOProvider;
